<template lang="pug">
.menu-float
  vs-row
    vs-tooltip(shadow v-for="(item, i) in menuItems" :key="i" class="menu-float__item")
      vs-button(:to="item.link"  size="large" :border="currentRoute !== item.link && !currentRoute.includes(item.link)" :floating="currentRoute.includes(item.link)")
        i(:class="`eva eva-${item.icon}`")
      template(#tooltip) {{ $t(item.name) }}
    vs-tooltip(shadow not-hover v-model="tooltip")
      vs-avatar(badge-color="white"  @click="tooltip =! tooltip" circle primary)
        template(#text) {{ $auth.user().name }}
      template(#tooltip)
        .content-options
          vs-button(@click="logout({ closable: true, target: 'tooltip' })" :loading="loading")
            | {{ $t('login.logout') }}
            template(#animate)
              i.eva.eva-log-out-outline
</template>

<script>
import { mapGetters } from 'vuex'
import AuthMixin from '../mixins/AuthMixin'
export default {
  name: 'NavigationMenu',
  components: {},
  mixins: [AuthMixin],
  data: () => ({
    activeItem: 0,
    active: 'pages',
    tooltip: false
  }),
  computed: {
    ...mapGetters([
      'menuItems'
    ]),
    currentRoute () {
      return this.$route.path
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.menu-float {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  border-radius: 8px;
  padding: 10px 20px;
  background-color: white;
  box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.5);
  -webkit-box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.5);
  &__item {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
